/**
 * Featured collection carousel: keep Quick shop / Choose options tappable on iOS
 * when Flickity is enabled, and prevent duplicate opens that race/cancel loads.
 */
(function () {
  var CAROUSEL_SELECTOR = '.featured-collection--content';
  var BUTTON_SELECTOR = '[data-quickshop-full], [data-quickshop-slim], [data-quick-buy], .productitem--action-trigger';
  var QUICKSHOP_BUTTON_SELECTOR = '[data-quickshop-full], [data-quickshop-slim], [data-quick-buy]';
  var COOLDOWN_MS = 800;
  var lastQuickshopOpenAt = 0;
  var quickshopOpenLocked = false;

  function isFeaturedCollectionButton(button) {
    return button && button.closest && button.closest(CAROUSEL_SELECTOR);
  }

  function shouldAllowQuickshopOpen() {
    var now = Date.now();

    if (quickshopOpenLocked || now - lastQuickshopOpenAt < COOLDOWN_MS) {
      return false;
    }

    lastQuickshopOpenAt = now;
    quickshopOpenLocked = true;
    window.setTimeout(function () {
      quickshopOpenLocked = false;
    }, COOLDOWN_MS);

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest(QUICKSHOP_BUTTON_SELECTOR);

      if (!button || !isFeaturedCollectionButton(button)) {
        return;
      }

      if (!shouldAllowQuickshopOpen()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.fcIosActionsInit === 'true') {
      return;
    }

    carousel.dataset.fcIosActionsInit = 'true';

    carousel.addEventListener(
      'touchstart',
      function (event) {
        if (event.target.closest && event.target.closest('[data-product-actions]')) {
          event.stopPropagation();
        }
      },
      { capture: true, passive: true }
    );

    carousel.addEventListener(
      'touchend',
      function (event) {
        var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);

        if (!button || !carousel.contains(button)) {
          return;
        }

        if (!button.matches(QUICKSHOP_BUTTON_SELECTOR)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        button.click();
      },
      { capture: true, passive: false }
    );
  }

  function scan() {
    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
